export * from './removed-foto-kategorie.event.interface';
